
import { DomainBox } from "@/components/shared/DomainBox";
import { Domain } from "@/types/domain";

interface DomainSectionProps {
  title: string;
  domains: Domain[];
  titleColor: string;
  domainKBs?: any[];
}

// Sample knowledge bases for Chevron domains - linked to Oil & Gas DEMO Marketplace solutions
const getChevronKnowledgeBases = (symbol: string) => {
  const symbolToSolutionMap: Record<string, string[]> = {
    // Upstream domains
    "E&P": ["og-006", "og-001", "og-003"],
    "DRILL": ["og-001", "og-008", "og-003"],
    "RES": ["og-003", "og-006", "og-001"],
    "PROD": ["og-001", "og-008", "og-006"],
    // Midstream domains
    "PIPE": ["og-002", "og-007", "og-010"],
    "TRANS": ["og-007", "og-002", "og-010"],
    "STORE": ["og-010", "og-002", "og-007"],
    // Downstream domains
    "REF": ["og-004", "og-009", "og-005"],
    "DIST": ["og-009", "og-004", "og-005"],
    "CARBON": ["og-005", "og-004", "og-009"]
  };

  const solutionIds = symbolToSolutionMap[symbol] || ["og-001", "og-002", "og-003"];
  
  return [
    { title: `${symbol} Standard Operating Procedures`, url: `/channel-solutions?channel=oil-gas&demo=true&id=${solutionIds[0]}` },
    { title: `${symbol} Technical Specifications`, url: `/channel-solutions?channel=oil-gas&demo=true&id=${solutionIds[1]}` },
    { title: `${symbol} Best Practices Guide`, url: `/channel-solutions?channel=oil-gas&demo=true&id=${solutionIds[2]}` }
  ];
};

export const DomainSection = ({ title, domains, titleColor, domainKBs = [] }: DomainSectionProps) => {
  // Get KB count for a domain
  const getKBCount = (domainName: string) => {
    if (!domainKBs || domainKBs.length === 0) return 0;
    return domainKBs.filter(kb => 
      kb.domains?.name === domainName
    ).length;
  };

  return (
    <div className="mb-8">
      <h2 className={`text-xl font-semibold mb-4 ${titleColor}`}>{title}</h2>
      <div className="grid grid-cols-3 gap-4">
        {domains.map((domain) => (
          <DomainBox
            key={domain.symbol + domain.name}
            domain={domain}
            getKnowledgeBases={getChevronKnowledgeBases}
            kbCount={getKBCount(domain.name)}
          />
        ))}
      </div>
    </div>
  );
};
